// @ts-nocheck
import { Button } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { type FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type DescriptionProps = {
  isDeleted?: boolean
  description?: string
  downloadStarted?: boolean
  testId?: string
}

const Description: FC<DescriptionProps> = ({
  isDeleted = false,
  description = '',
  downloadStarted = false,
  testId
}) => {
  const baseId = testId || 'description'
  const [isCollapsed, setCollapsed] = useState(true)
  const isDescriptionLongerThan500 = description?.length > 500

  let renderedDescription = description

  if (isDescriptionLongerThan500 && isCollapsed && !downloadStarted) {
    renderedDescription = `${description.substring(0, 500)}...`
  }

  const onButtonClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    state: boolean
  ) => {
    event.preventDefault()

    setCollapsed(state)
  }

  const { t } = useTranslation()

  return (
    <TextStyled data-testid={baseId}>
      {isDeleted ? null : renderedDescription}
      {isDescriptionLongerThan500 && isCollapsed && !downloadStarted && (
        <ButtonStyled
          variant="text"
          onClick={(event) => onButtonClick(event, false)}
          data-testid={`${baseId}-show-more`}
        >
          {t('general.buttons.showMore')}
        </ButtonStyled>
      )}
      {isDescriptionLongerThan500 && !isCollapsed && !downloadStarted && (
        <ButtonStyled
          variant="text"
          onClick={(event) => onButtonClick(event, true)}
          data-testid={`${baseId}-show-less`}
        >
          {t('general.buttons.showLess')}
        </ButtonStyled>
      )}
    </TextStyled>
  )
}

const TextStyled = styled(Text)`
  color: initial;
  display: initial;
  white-space: pre-wrap;
`
const ButtonStyled = styled(Button)`
  margin-left: 10px;
  display: inline;
` as typeof Button

export default Description
